module.exports = __webpack_public_path__ + "img/ne.e56edd30.svg";